import { render, staticRenderFns } from "./BillPaymentForm.vue?vue&type=template&id=1296e914&"
import script from "./BillPaymentForm.vue?vue&type=script&lang=ts&"
export * from "./BillPaymentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports